<template>
  <div>
    <header>
      <navbar id="navbar"/>
    </header>
    <main>
      <transition name="page-transition" mode="out-in">
        <keep-alive>
          <router-view :key="$route.path"></router-view>
        </keep-alive>
      </transition>
      <tabBar></tabBar>
    </main>
    <footer>
      <MunFooter id="munFooter"/>
    </footer>
    <!-- <rewards></rewards> -->
  </div>
</template>

<script>
import Navbar from "@/components/navbar";
import MunFooter from "@/components/munFooter";
import Rewards from "../components/rewards";
import tabBar from "../components/tabBar";

export default {
  name: "index",
  components: {
    Rewards,
    MunFooter,
    Navbar,
    tabBar,
  }
}
</script>

<style scoped>
.page-transition-enter-active,
.page-transition-leave-active {
  transition: opacity 0.28s ease, transform 0.28s ease;
}

.page-transition-enter {
  opacity: 0;
  transform: translateY(18px);
}

.page-transition-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@media (prefers-reduced-motion: reduce) {
  .page-transition-enter-active,
  .page-transition-leave-active {
    transition: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue